<template>
    <div>
        <div class="w-full max-w-md mx-auto flex justify-center">
            <button @click.prevent="toggleEnableSocketLog" class="btn font-opensans">
                Socket Log: {{ enableSocketLog ? 'ON' : 'OFF' }}
            </button>
        </div>
        <div class="w-full max-w-md mx-auto flex justify-center">
            <button @click.prevent="onClearIntroLocal" :disabled="disabledIntro" class="btn font-opensans mt-4">
                Clear Intro LocalStorage
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SocketLog',

    data() {
        return {
            enableSocketLog: false,
            disabledIntro: false,
            socketDebugKey: 'socket-debug',
            introKey: 'intro-step'
        }
    },

    mounted() {
        this.enableSocketLog = window.localStorage.getItem(this.socketDebugKey) == 1
        this.disabledIntro = window.localStorage.getItem(this.introKey) == null
    },

    methods: {
        toggleEnableSocketLog() {
            const status = this.enableSocketLog == 1 ? 0 : 1
            this.enableSocketLog = status
            window.localStorage.setItem(this.socketDebugKey, status)
        },

        onClearIntroLocal() {
            this.disabledIntro = true
            window.localStorage.removeItem(this.introKey)
        }
    }
}
</script>
